/* Reuse the merchant's existing official SDKs. No estimated payments are calculated here. */
(() => {
  'use strict';
  const panels=[...document.querySelectorAll('[data-product-financing]')];
  if(!panels.length)return;
  const getContext=()=>{
    const c=window.LIVVOLTFinancingConfig||{};
    return {...c,country:c.country||window.Shopify?.country||'',currency:c.currency||window.Shopify?.currency?.active||'',accountCountry:c.accountCountry||''};
  };
  panels.forEach(panel=>{
    const rows=[...panel.querySelectorAll('[data-financing-provider]')];
    let amount=Number(panel.dataset.unitPrice)||0;
    let contextKey='',observers=[],timer=0,raf=0,attempt=0;
    let initialized={affirm:false,klarna:false};
    const hasPrice=text=>/[$€£]\s*\d[\d.,]*\s*(?:\/\s*(?:mo(?:nth)?|payment)|per\s+(?:month|payment|instalment|installment)|a\s+month|each)/i.test(text)
      ||/\b(?:payments?|instalments?|installments?)\s+(?:of|from|at)\s*[$€£]\s*\d/i.test(text);
    function readQuote(row){
      if(row.dataset.financingProvider==='affirm')return row.querySelector('.affirm-as-low-as')?.textContent||'';
      const placement=row.querySelector('klarna-placement');
      const message=placement?.shadowRoot?.querySelector('[part~="osm-message"]');
      // Do not infer success from element height: empty branded boxes are not offers.
      return message?.textContent||'';
    }
    function inspect(){
      raf=0;
      for(const row of rows){
        const placement=row.querySelector('klarna-placement');
        if(placement?.shadowRoot&&!placement.__lvQuoteObserved){
          const observer=new MutationObserver(scheduleInspect);
          observer.observe(placement.shadowRoot,{subtree:true,childList:true,characterData:true});
          observers.push(observer);placement.__lvQuoteObserved=true;
        }
        const visible=hasPrice(readQuote(row));
        if(row.dataset.quoteVisible!==String(visible))row.dataset.quoteVisible=String(visible);
        row.setAttribute('aria-hidden',String(!visible));
      }
      panel.dataset.hasOffers=String(rows.some(r=>r.dataset.quoteVisible==='true'));
    }
    function scheduleInspect(){if(!raf)raf=requestAnimationFrame(inspect);}
    function refreshOfficial(){
      try{window.affirm?.ui?.refresh?.();}catch(_){/* Provider unavailable: remain hidden. */}
      try{window.Klarna?.OnsiteMessaging?.refresh?.();}catch(_){/* Provider unavailable: remain hidden. */}
      scheduleInspect();
    }
    function initProviders(){
      if(panel.querySelector('.affirm-as-low-as')&&window.affirm?.ui&&!initialized.affirm){
        initialized.affirm=true;
        if(window.affirm.ui.ready)window.affirm.ui.ready(()=>{refreshOfficial();});
        else refreshOfficial();
      }
      if(panel.querySelector('klarna-placement')&&window.Klarna?.OnsiteMessaging&&!initialized.klarna){
        initialized.klarna=true;refreshOfficial();
      }
      inspect();
      if(++attempt<32)timer=setTimeout(initProviders,250);
    }
    function configure(){
      const config=getContext();
      // Only the merchant's currently verified US/USD program is enabled by default.
      // These are merchant settings, not a claim that either provider serves only the US.
      const markets=config.markets||{affirm:[{country:'US',currency:'USD'}],klarna:[{country:'US',currency:'USD'}]};
      const key=JSON.stringify([config.country,config.currency,config.accountCountry,config.enabled,markets]);
      if(key===contextKey)return;
      contextKey=key;clearTimeout(timer);observers.forEach(o=>o.disconnect());observers=[];
      attempt=0;initialized={affirm:false,klarna:false};
      for(const row of rows){
        row.replaceChildren();row.dataset.quoteVisible='false';row.setAttribute('aria-hidden','true');
        const name=row.dataset.financingProvider;
        const allowed=config.enabled!==false&&amount>0&&(!config.accountCountry||config.accountCountry===config.country)
          &&(markets[name]||[]).some(m=>m.country===config.country&&m.currency===config.currency);
        if(!allowed)continue;
        if(name==='affirm'){
          const node=document.createElement('p');
          node.className='affirm-as-low-as';node.dataset.pageType='product';node.dataset.amount=String(amount);
          // Prevent the existing theme helper from creating a second Klarna placement.
          node.dataset.lvKlarnaReady='true';row.append(node);
        }else{
          const node=document.createElement('klarna-placement');
          node.dataset.key='credit-promotion-auto-size';node.dataset.locale=config.klarnaLocale||'en-US';
          node.dataset.purchaseAmount=String(amount);node.dataset.theme='default';node.dataset.messagePreference='klarna';
          row.append(node);
        }
        const observer=new MutationObserver(scheduleInspect);
        observer.observe(row,{subtree:true,childList:true,characterData:true});observers.push(observer);
      }
      if(panel.querySelector('klarna-placement')&&window.customElements)customElements.whenDefined('klarna-placement').then(scheduleInspect);
      if(panel.querySelector('.affirm-as-low-as,klarna-placement'))initProviders();
      else inspect();
    }
    panel.addEventListener('livvolt:financing-update',event=>{
      const value=Number(event.detail?.amount);
      if(!Number.isSafeInteger(value)||value<=0||value===amount)return;
      amount=value;panel.dataset.amount=String(amount);
      // Recreate placements so a previous amount's shadow-DOM quote cannot flash.
      contextKey='';configure();
    });
    window.addEventListener('livvolt:financing-context',()=>{contextKey='';configure();});
    configure();
  });
})();
